import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import styled from 'styled-components';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { LocationIcon } from '~/img';
import colors from '~/constants/colors';
import { HandbookRes } from '~/types/Handbook';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';
import direction from '~/utils/direction';

function regionCell(handbook?: HandbookRes): ColumnsType<any>[0] {
  return {
    title: () => (
      <TableHeader title={getI18n().t('Region', { ns: 'agent' })} sortingDataKey="region" />
    ),
    dataIndex: 'region',
    key: 'region',
    render: (region) => {
      const regionLocalized = handbook?.handbooks
        ?.find((item) => item.key === 'region')
        ?.values?.find((item) => item.apiValue === region)
        ?.localizedValue;
      return (
        <Container dir={getI18n().dir()}>
          <LocationIcon className="agentTableLocationIcon" />
          <CellText className="agentTableRegionTitle">{regionLocalized || region}</CellText>
        </Container>
      );
    },
    width: 160,
  };
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .agentTableLocationIcon {
    color: ${colors.borderColorBase};
  }

  .agentTableRegionTitle {
    ${direction.margin.left(5)};
  }
`;

export default regionCell;
